import React, { useMemo } from 'react';

interface BackButtonProps {
  dark: boolean;
  handleBack: () => void;
  hasText: boolean;
  size: 'small' | 'medium' | 'large';
}

export function BackButton({ dark, handleBack, hasText, size }: BackButtonProps) {
  const style = useMemo(() => {
    switch (size) {
      case 'small':
        return { fontSize: '12px' };
      case 'medium':
        return { fontSize: '16px' };
      case 'large':
        return { fontSize: '24px' };
    }
  }, [ size ]);

  return (
    <span 
      style={style} 
      className={`back-button ${dark ? 'dark' : ''}`} 
      onClick={handleBack}
    >
      {hasText ? '< Back' : '<'}
    </span>
  );
}
